import { DataModel } from "common/models/utility-models/base-model";

export class DocumentReportsModel extends DataModel {
    selectedBatch: string = '';
    selectedRegion: string = '';
    selectedState: string = '';
    selectedBranch: string = '';
    selectedGender: string = '';
    selectedDocumentType: string = '';
    selectedPeriod: string = '';
    selectedDocument: string = '';
    selectedUploadFilter: string = '';
}